module.exports = __webpack_public_path__ + "static/img/icon-EN.c7c1c63b.svg";